export const isInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  
  if (ua.indexOf('Instagram') > -1) return 'instagram';
  if (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1) return 'facebook';
  if (ua.indexOf('Messenger') > -1) return 'messenger';
  
  return false;
};

export const getBrowserName = () => {
  const browser = isInAppBrowser();
  if (browser === 'instagram') return 'Instagram';
  if (browser === 'facebook') return 'Facebook';
  if (browser === 'messenger') return 'Messenger';
  return null;
};

export const shouldShowBrowserWarning = () => {
  return isInAppBrowser() !== false;
};
